const initialState = {
  width: typeof window === 'object' ? window.innerWidth : 1024,
  height: typeof window === 'object' ? window.innerHeight : 800,
  /* eslint-disable eqeqeq */
  inFrame: (window != window.top)
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SCREEN_RESIZE': {
      if (typeof window === 'object') {
        if (window.parent) {
          window.parent.postMessage({
            origin: window.location.href,
            height: document.querySelector("body").clientHeight + 40
          }, '*');
        }
        return { ...state, width: window.innerWidth, height: window.innerHeight }
      }
      break;
    }
    default:
  }
  return state
};



// WEBPACK FOOTER //
// ./src/reducers/screen.js